import compareVersions from 'compare-versions';
import { dataVersion } from '../../package.json';

export let oldVersion = localStorage.getItem('configurator-version');
if (!oldVersion) oldVersion = '1.0.0';
if (compareVersions(dataVersion, oldVersion) > 0) {
  localStorage.setItem('configurator-version', dataVersion);
  localStorage.removeItem('colors');
  localStorage.removeItem('piecesData');
  localStorage.removeItem('furniture');
}
